import React, { useState } from 'react';
import { Menu, X, Utensils } from 'lucide-react';
import useMobile from '../hooks/useMobile';

const Header = ({ currentPage, setCurrentPage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useMobile();

  const navigation = [
    { name: 'Home', id: 'home' },
    { name: 'Products & Services', id: 'products' },
    { name: 'Support', id: 'support' }
  ];

  return (
    <nav style={{
      backgroundColor: '#fff',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div className="container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '70px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Utensils size={32} color="#7c3aed" style={{ marginRight: '10px' }} />
          <span style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>Krafty Restaurants</span>
        </div>
        
        {/* Desktop Navigation */}
        <div style={{
          display: isMobile ? 'none' : 'flex',
          gap: '30px',
          alignItems: 'center'
        }}>
          {navigation.map((item) => (
            <button
              key={item.id}
              onClick={() => setCurrentPage(item.id)}
              style={{
                background: 'none',
                border: 'none',
                padding: '8px 16px',
                fontSize: '1rem',
                cursor: 'pointer',
                borderBottom: '2px solid transparent',
                ...(currentPage === item.id ? {
                  color: '#7c3aed',
                  borderBottomColor: '#7c3aed'
                } : {})
              }}
            >
              {item.name}
            </button>
          ))}
          <button style={{
            backgroundColor: '#7c3aed',
            color: 'white',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '8px',
            fontSize: '1rem',
            cursor: 'pointer'
          }}>
            Get Started
          </button>
        </div>

        {/* Mobile menu button */}
        <button
          style={{
            display: isMobile ? 'block' : 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && isMobile && (
        <div style={{
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px'
        }}>
          {navigation.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setCurrentPage(item.id);
                setMobileMenuOpen(false);
              }}
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'left',
                background: 'none',
                border: 'none',
                padding: '12px',
                fontSize: '1rem',
                cursor: 'pointer',
                ...(currentPage === item.id ? {
                  color: '#7c3aed',
                  backgroundColor: '#f3f4f6'
                } : {})
              }}
            >
              {item.name}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Header;